<template>
  <div>
    <TwTable :searchData="searchData" :tableData="tableData" :tableConfig="tableConfig" :pageConfig="pageConfig"
      :filters="filters" :buttonList="buttonList" @resetBtn="resetBtn" @btnCallFunction="callFunction"
      @handleCellClick="handleCellClick" @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox" @searchChange="searchChange" @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle" @handleSelsChange="handleSelsChange" @handleOperateEvent="handleOperateEvent">
      <template slot-scope="scope" slot="proportionDesc">
        <el-tag type="success" v-if="scope.row.proportionStatus == 1">宽松</el-tag>
        <el-tag type="warning" v-if="scope.row.proportionStatus == 2">紧张</el-tag>
        <el-tag type="danger" v-if="scope.row.proportionStatus == 3">约满</el-tag>
      </template>
    </TwTable>
  </div>
</template>
    
<script>
import {
  GetBookingDeliveryReport,
  exportBookingDeliveryReport
} from "@/api/bookingdelivery.js";
import TwTable from "../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import { arrToJoin } from "util/util";
export default {
  components: {
    TwTable,
  },
  mixins: [TwTable_mixins],
  data() {
    return {
      tableConfig: {
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showResetButton: true,
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: false, // 显示操作栏
        operate: {
        },
        column: [
          // 表格列配置
          {
            prop: "estimatedDate",
            label: "日期",
            minWidth: "120",
          },
          {
            prop: "expectedTime",
            label: "时间段",
            minWidth: "120",
          },
          {
            prop: "count",
            label: "票数",
            minWidth: "80",
          },
          {
            prop: "deliveryQty",
            label: "箱数",
            minWidth: "80",
          },
          {
            prop: "deliveryWeight",
            label: "重量",
          },
          {
            prop: "deliveryVolume",
            label: "体积cbm",
          },
          {
            prop: "proportionDesc",
            label: "状态",
            slot: true,
          },
        ],
      },
      searchData: {
        //搜索列配置
        search: [
          {
            type: "daterange",
            key: "ExpectedTime",
            label: "预约时间",
          },
          {
            type: "select",
            key: "ProportionStatus",
            label: "状态",
            multiple: true,
            clearable: true,
            options: [
              {
                label: "宽松",
                value: '1',
              },
              {
                label: "紧张",
                value: '2',
              },
              {
                label: "约满",
                value: '3',
              },
            ]
          }
        ],
        ///高级搜索配置
        moreSearch: [],
      },
      filters: {
        ExpectedTime: []
      }
      //-------------
    };
  },
  methods: {
    initializeDates() {
      const today = new Date();
      const sevenDaysAgo = new Date(today);
      sevenDaysAgo.setDate(today.getDate() - 15); 

      const sevenDaysAfter = new Date(today);
      sevenDaysAfter.setDate(today.getDate() + 15);

      //this.filters.ExpectedTime=[this.formatDate(sevenDaysAgo),this.formatDate(sevenDaysAfter)];

      this.$set(this.filters, "ExpectedTime", [this.formatDate(sevenDaysAgo),this.formatDate(sevenDaysAfter)]);
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    //查询日志
    getbusinessLoglist(row) {
      this.currentRow = row;
      this.showLog = true;
    },

    handleExport() {
      const { ProportionStatus } = this.filters;
      let para = {
        page: 1,
        pageSize: 60001,
        ...this.filters,
        ProportionStatus: ProportionStatus
      };
      this.exportFile(exportBookingDeliveryReport, para);

    },

    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },
    //查询列表
    initTable() {
      const { ProportionStatus } = this.filters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize || 50,
        ...this.filters,
        ProportionStatus: ProportionStatus
      };
      this.getTableData(GetBookingDeliveryReport, para).then((res) => {

      })
    },
    getButtonIndex(fnName) {
      let fnIndex = 0
      this.buttonList.forEach((item, index) => {
        if (item.func == fnName) {
          fnIndex = index
          return
        }
      })
      return fnIndex
    },
    resetBtn() {
      //this.filters = { ExpectedTime: ["2023-10-24", "2023-11-23"] };
      this.initializeDates();
    },
  },

  mounted() {
    this.initializeDates();
    // 获取按钮配置
    this.getMixinsButtonList();
  },
};
</script>
  